import script from "./RegistroAccessi.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistroAccessi.vue?vue&type=script&setup=true&lang=ts"

import "./RegistroAccessi.vue?vue&type=style&index=0&id=50257e63&lang=css"

const __exports__ = script;

export default __exports__